import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

export default function ContainerWithBackgroundImg(props) {
  const { children } = props;
  const fadeIn = keyframes`
    0%   { opacity: 0; }
    100% { opacity: 1; }
  `;

  const StyledContainerWithBackground = styled.div`
    margin-top: ${props.marginTop ? props.marginTop : '10vh'};
    height: ${props.height};
    width: ${props.width};
    background-size: cover;
    background-position: center;
    transition: all 0.5s ease;
    background-image: url('${props.image}');
    /*animation: ${fadeIn} 1s forwards;*/
    max-width: ${props.maxWidth};
    max-height: ${props.maxHeight};
  `;

  return (
    <Grid container justify="center" alignItems="center">
      <Grid item>
        <StyledContainerWithBackground>
          {children}
        </StyledContainerWithBackground>
      </Grid>
    </Grid>
  );
}

ContainerWithBackgroundImg.propTypes = {
  children: PropTypes.node.isRequired,
};
